export const isSimilarSuggestion = (currentSuggestions, startDate) => {
  return Object.values(currentSuggestions).some(
    suggestion => suggestion.startDate === startDate
  )
}
